import { useState } from "react";
import { FontFa } from "../../../../components";
import { useProcess } from "../../process-context";

export const PinLayout = () => {
  const { updatePin = () => {}, isPin = () => false } = useProcess();

  const [isPinRequest, setIsPinRequest] = useState(isPin());

  const handleUpdatePin = () => {
    setIsPinRequest(!isPinRequest);
    updatePin(!isPinRequest);
  };

  return (
    <span title="Nhấn để ghim phiếu" onClick={handleUpdatePin} role="button">
      <FontFa name="faThumbtack" color={isPinRequest ? "#FC6466" : undefined} />
    </span>
  );
};
